import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { WholesaleOrder } from "@shared/types/graphqlGenerated";

const InternalWholesaleCarts_Shared_Query = gql`
  query InternalWholesaleCarts_Shared_Query {
    currentPractitioner {
      id
      internalWholesaleCarts {
        id
        _legacyId
        isCreatedByPractitioner
        lineItems {
          id
          quantity
        }
      }
    }
  }
`;

interface InternalWholesaleCartsQueryData {
  currentPractitioner: {
    id: string;
    internalWholesaleCarts: Pick<
      WholesaleOrder,
      "id" | "isCreatedByPractitioner" | "_legacyId" | "lineItems"
    >[];
  };
}

const useInternalWholesaleCartsQuery = (
  options?: QueryHookOptions<InternalWholesaleCartsQueryData>
) => useQuery<InternalWholesaleCartsQueryData>(InternalWholesaleCarts_Shared_Query, options);

export type { InternalWholesaleCartsQueryData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useInternalWholesaleCartsQuery, InternalWholesaleCarts_Shared_Query };
